export enum OperatorType {
    LT, LE, EQ, NE, GE, GT, NV, EV
}

export function getOperatorType(name: string) {
   switch (name) {
       case "LT": return OperatorType.LT;
       case "<": return OperatorType.LT;
       case "LE": return OperatorType.LE;
       case "<=": return OperatorType.LE;
       case "EQ": return OperatorType.EQ;
       case "=": return OperatorType.EQ;
       case "NE": return OperatorType.NE;
       case "<>": return OperatorType.NE;
       case ">=": return OperatorType.GE;
       case "GE": return OperatorType.GE;
       case "GT": return OperatorType.GT;
       case ">": return OperatorType.GT;
       case "NV": return OperatorType.NV; // Not void
       case "EV": return OperatorType.EV; // Equals void
       default: return null;
   }
}